import React, {Component} from 'react';
import {DATA} from './sampleData2';
import Level from './level';
import {get} from '../services';
import {Player} from "video-react";
import Part from './part2.0';
import '../index.scss';
import QAWorkPanel from "./section2.0";

let levels = DATA.levels;

class EzTopApp extends Component {


	constructor(props) {
		super(props);
		this.state = {
			currentIndex:     0,
			levels:           [],
			selectedLevel:    null,
			currentPartIndex: 0,
			selectedPart:     null,
			videoCollapse:    false
		}
	}

	componentDidMount() {
		get().then(result => {
			this.setState({
				currentIndex:     0,
				levels:           result.data.levels,
				selectedLevel:    result.data.levels[0],
				currentPartIndex: 0,
				selectedPart:     result.data.levels[0] ? (result.data.levels[0].parts ? result.data.levels[0].parts[0] : null) : null
			})
		});
		// this.setState({
		// 	currentIndex: 0,
		// 	levels: levels,
		// 	selectedLevel: levels[0],
		// 	currentPartIndex: 0,
		// 	selectedPart: levels[0] ? (levels[0].parts ? levels[0].parts[0] : null) : null
		// })

	}


	renderSelectedLevel() {
		return <Level level={this.state.selectedLevel}></Level>
	}

	handleLevelButtonOnClick = (e, index, levels) => {
		e.preventDefault();
		this.setState({
			currentIndex:     index,
			selectedLevel:    levels[index],
			currentPartIndex: 0,
			selectedPart:     levels[index] ? (levels[index].parts ? levels[index].parts[0] : null) : null
		});
		this.refs.player.load();
	}

	handlePartButtonOnClick = (e, index, parts) => {
		e.preventDefault();
		this.setState({
			selectedPart:     parts[index],
			currentPartIndex: index
		});
		this.refs.player.load();
	}


	renderDescription(description) {
		if(description instanceof Object){
			return (
				<>
					<h5>
						{description.header}
					</h5>
					{description.contents.map((item, index) => {
						return <p key={index}>{item}</p>
					})}
				</>
			)
		}
		else{
			return (
				<>
					<p>{description}</p>
				</>
			)
		}

	}


	triggerVideoCollapse(e) {
		e.preventDefault();
		this.setState({
			videoCollapse: !this.state.videoCollapse
		}, () => {
			if(!this.state.videoCollapse){
				this.refs.player.pause();
			}
		});
	}


	renderVideo(video) {
		let className = this.state.videoCollapse ? "videoPlayer" : "videoPlayer hide";
		return (


			<>
				<a className="show-questions-button" href="#" onClick={(e) => this.triggerVideoCollapse(e)}>{this.state.videoCollapse ? "Hide Video" : "Show Video"} <b>Tap Here</b></a>
				<Player ref="player" fluid={true} className={className}>
					<source src={video}/>
				</Player>
			</>
		)
	}


	render() {
		const {levels} = this.state;
		if(levels && levels.length > 0){
			const {parts}                        = this.state.selectedLevel;
			const {sections, video, description} = this.state.selectedPart;
			return (
				<div className="ezTop_public">
					<div className="app-container">
						<div className="app-header">
							<ul className="level-selector">
								<li><a href="#" className={this.state.currentIndex === 0 ? 'active' : ''} onClick={(e) => this.handleLevelButtonOnClick(e, 0, levels)}>Level B</a></li>
								<li><a href="#" className={this.state.currentIndex === 1 ? 'active' : ''} onClick={(e) => this.handleLevelButtonOnClick(e, 1, levels)}>Level C</a></li>
							</ul>
							<ul className="part-selector">
								<li><a href="#" className={this.state.currentPartIndex === 0 ? ' part-button active' : 'part-button'} onClick={(e) => this.handlePartButtonOnClick(e, 0, parts)}>PART
									1</a>
								</li>
								<li><a href="#" className={this.state.currentPartIndex === 1 ? ' part-button active' : 'part-button'} onClick={(e) => this.handlePartButtonOnClick(e, 1, parts)}>PART
									2</a>
								</li>
								<li><a href="#" className={this.state.currentPartIndex === 2 ? ' part-button active' : 'part-button'} onClick={(e) => this.handlePartButtonOnClick(e, 2, parts)}>PART
									3</a>
								</li>
								<li><a href="#" className={this.state.currentPartIndex === 3 ? ' part-button active' : 'part-button'} onClick={(e) => this.handlePartButtonOnClick(e, 3, parts)}>PART
									4</a>
								</li>
							</ul>
							{this.renderDescription(description)}
						</div>
						<div>
							<Part part={this.state.selectedPart} index={this.state.currentPartIndex}/>
						</div>
						<div>
							{video && this.renderVideo(video)}
						</div>
					</div>
				</div>
			);
		}
		else{
			return (
				<div>Loading...</div>
			)
		}
	}
}

export default EzTopApp;
